module.exports = __webpack_public_path__ + "static/team-8-b3bde201e995ddf8928001ee1b6657b2.png";